<template>
  <v-tooltip v-if="shouldShowTooltip" location="top">
    <template #activator="{ props }">
      <span v-bind="props" :class="textClass">{{ displayText }}</span>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>

  <span v-else :class="textClass">{{ displayText }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAccountSettingsStore } from '@/stores/accountSettings'
import { dealerTimeTooltipText, formatDateTimeWithTzShort, formatTimeWithTzShort } from '@/utils'

const props = withDefaults(
  defineProps<{
    value: unknown
    kind?: 'dateTime' | 'time'
    text?: string
    emptyText?: string
    tooltipLabel?: string
    textClass?: string
  }>(),
  {
    kind: 'dateTime',
    text: '',
    emptyText: '—',
    tooltipLabel: 'Dealer time',
    textClass: '',
  },
)

const accountSettings = useAccountSettingsStore()

const dealerTimeZone = computed(() => String(accountSettings.dealerTimeZone || '').trim())

const parsedDate = computed(() => {
  const d = new Date(props.value as any)
  return Number.isNaN(d.getTime()) ? null : d
})

const displayText = computed(() => {
  const t = String(props.text || '').trim()
  if (t) return t
  if (!parsedDate.value) return props.emptyText
  return props.kind === 'time' ? formatTimeWithTzShort(parsedDate.value) : formatDateTimeWithTzShort(parsedDate.value)
})

const shouldShowTooltip = computed(() => {
  return !!parsedDate.value
})

const tooltipText = computed(() => {
  if (!shouldShowTooltip.value) return ''
  return dealerTimeTooltipText({
    value: parsedDate.value,
    dealerTimeZone: dealerTimeZone.value,
    kind: props.kind,
    label: props.tooltipLabel,
  })
})
</script>

